var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.817,
    height: 300.818,
    viewBox: "0 0 300.817 300.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1487",
    "data-name": "Rectangle 1487",
    width: 300.817,
    height: 300.818,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(-0.001)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_184_1",
    "data-name": "Component 184 \\u2013 1",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M150.41,300.818C67.474,300.818,0,233.344,0,150.407S67.474,0,150.41,0,300.819,67.473,300.819,150.407,233.345,300.818,150.41,300.818M150.41,6C70.785,6,6,70.782,6,150.407S70.785,294.815,150.41,294.815s144.405-64.782,144.405-144.408S230.036,6,150.41,6",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M142.526,274.158c-72.581,0-131.63-59.05-131.63-131.633S69.945,10.9,142.526,10.9s131.63,59.048,131.63,131.631-59.049,131.633-131.63,131.633m0-257.262A125.629,125.629,0,1,0,268.155,142.526,125.773,125.773,0,0,0,142.526,16.9",
    transform: "translate(7.884 7.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M134.644,247.5A112.853,112.853,0,1,1,247.5,134.642,112.981,112.981,0,0,1,134.644,247.5m0-219.705A106.851,106.851,0,1,0,241.495,134.642,106.972,106.972,0,0,0,134.644,27.79",
    transform: "translate(15.766 15.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M126.761,220.835a94.075,94.075,0,1,1,94.076-94.076,94.183,94.183,0,0,1-94.076,94.076m0-182.149a88.073,88.073,0,1,0,88.074,88.073,88.174,88.174,0,0,0-88.074-88.073",
    transform: "translate(23.65 23.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M118.878,194.174a75.3,75.3,0,1,1,75.3-75.3,75.384,75.384,0,0,1-75.3,75.3m0-144.594a69.3,69.3,0,1,0,69.294,69.294A69.374,69.374,0,0,0,118.878,49.58",
    transform: "translate(31.532 31.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M110.995,167.514a56.52,56.52,0,1,1,56.519-56.521,56.585,56.585,0,0,1-56.519,56.521m0-107.039a50.518,50.518,0,1,0,50.518,50.518,50.576,50.576,0,0,0-50.518-50.518",
    transform: "translate(39.415 39.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M103.111,140.852a37.742,37.742,0,1,1,37.741-37.743,37.784,37.784,0,0,1-37.741,37.743m0-69.482a31.74,31.74,0,1,0,31.739,31.74,31.776,31.776,0,0,0-31.739-31.74",
    transform: "translate(47.299 47.298)",
    fill: "#fff"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBg);
export default __webpack_public_path__ + "static/media/circular-bg.8fe16610f0c963be0d35b6ec645cdc71.svg";
export { ForwardRef as ReactComponent };